import React, { useState } from 'react'
// import { Link, navigate } from "@reach/router";
import { ListGroup, Button, Modal } from "react-bootstrap";

const ListaPropuestas = ({ inactivos, reFetch, isBusy, aprobar, borrar }) => {
  const [showBorrar, setShowBorrar] = useState(false)
  const [showAprobar, setShowAprobar] = useState(false)

  const handleCloseBorrar = () => setShowBorrar(false)
  const handleShowBorrar = () => setShowBorrar(true)
  const handleCloseAprobar = () => setShowAprobar(false)
  const handleShowAprobar = () => setShowAprobar(true)

  if (inactivos.length === 0) return <p>No hay usuarios nuevos</p>

  return <>
    {inactivos.map((usuario) => {

      const id = usuario._id

      return (
        <ListGroup.Item
          // className="is-clickable"
          key={id}
        >
          <div style={{
            width: '100%',
            display: 'grid',
            gridAutoFlow: 'column',
            justifyContent: 'space-between',
          }}>
            <span>{usuario.displayName} - {usuario.email}</span>
            <div style={{ width: 120, textAlign: 'right' }}>
              <Button variant="danger" onClick={handleShowBorrar}>
                <i className="fas fa-trash"></i>
              </Button>
              <Button onClick={handleShowAprobar}>
                <i className="fas fa-check"></i>
              </Button>
            </div>
          </div>
          <Modal show={showBorrar} onHide={handleCloseBorrar}>
            <Modal.Header closeButton>
              <Modal.Title>Borrar Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>¿Desea borrar permanentemente un usuario? ¡Esto no se puede deshacer!</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseBorrar}>
                Cancelar
          </Button>
              <Button disabled={isBusy} variant="primary" onClick={async () => {
                const res = await borrar(id)
                handleCloseBorrar()
                if (res) {
                  reFetch()
                } else {
                  alert('Ocurrió un error desconocido.')
                }
              }}>
                Borrar
          </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={showAprobar} onHide={handleCloseAprobar}>
            <Modal.Header closeButton>
              <Modal.Title>Aprobar Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>¿Desea autorizar a este usuario a participar de la edción de Biblioteca?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseAprobar}>
                Cancelar
          </Button>
              <Button disabled={isBusy} variant="primary" onClick={async () => {
                const res = await aprobar(id)
                handleCloseBorrar()
                if (res) {
                  reFetch()
                } else {
                  alert('Ocurrió un error desconocido.')
                }
              }}>
                Aprobar
          </Button>
            </Modal.Footer>
          </Modal>
        </ListGroup.Item>
      );
    })}
  </>
}

export default ListaPropuestas